<mat-form-field appearance="outline" [ngClass]="{expanded: expanded}" class="form-field">
  <mat-chip-grid *ngIf="multiselect" #chipList [attr.aria-label]="placeholder"
    (click)="openTypeahead($event)" (focus)="openTypeahead($event)">
    <mat-chip-row *ngFor="let chipValue of value; index as chipIndex"
      (removed)="removeChip(chipIndex)" (click)="openTypeahead($event)"
      [ngClass]="{hide: !expanded && chipIndex > 0, peek: hasOverFlow}">
      {{ getDisplayText(chipValue) }}
      <mat-icon *ngIf="!hasOverFlow" matChipRemove>cancel</mat-icon>
    </mat-chip-row>
    <mat-chip-row *ngIf="hasOverFlow" (click)="openTypeahead($event)" class="overflow gray-chip">+{{ value.length - 1 }}</mat-chip-row>
    <input #typeaheadInputElement [formControl]="typeaheadInput"
      [placeholder]="hasValue ? '' : placeholder"
      [matAutocomplete]="autoOptions" [matChipInputFor]="chipList"
      [ngClass]="{hide: !expanded && typeaheadInputElement.value.length === 0 && value.length > 0}" class="chip-input">
  </mat-chip-grid>
  <div *ngIf="!multiselect && hasValue && !trigger?.panelOpen" (click)="openTypeahead($event)" class="value-wrapper">
    <span>{{ getDisplayText($any(value)) }}</span>
    <mat-icon *ngIf="disabled" class="xs arrow mat-field-disabled-grey">arrow_drop_down</mat-icon>
    <mat-icon *ngIf="!disabled" class="xs" (click)="clearValue($event)">clear</mat-icon>
  </div>
  <mat-error *ngFor="let error of errors | keyvalue">{{ error.value }}</mat-error>
  <div *ngIf="!multiselect" class="input-wrapper" [ngClass]="{ 'hide-input': hasValue && !trigger?.panelOpen }">
    <input matInput
      #typeaheadInputElement
      [formControl]="typeaheadInput"
      [placeholder]="hasValue ? '' : placeholder"
      [matAutocomplete]="autoOptions">
    <mat-icon class="xs arrow">arrow_drop_down</mat-icon>
  </div>
</mat-form-field>
<!-- FIXME: This should be modernized https://v17.material.angular.dev/components/autocomplete/overview#autocomplete-filter -->
<mat-autocomplete #autoOptions
  hideSingleSelectionIndicator
  (optionSelected)="selectOption($event)"
  panelWidth="auto">
  <!-- the $any() throughout here are to disable typechecking as this was written before we enabled template typechecking -->
  <mat-option *ngFor="let option of typeaheadOptions$ | async | slice:0:20" [value]="option.value" (click)="$event.stopPropagation()">
    <div *ngIf="$any(option).email && $any(option)._id" style="display:flex; align-items:center;">
      <app-avatar [users]="$any(option)" [enablePopover]="false" [enableAnimation]="false"></app-avatar>
      <div style="margin:0 5px;">
        {{ option.label }}
        <span class="text-muted user-email">{{ $any(option).email }}</span>
      </div>
    </div>
    <div *ngIf="!$any(option).email">
      {{ option.label }}
    </div>
  </mat-option>
</mat-autocomplete>
